

import React, { useMemo } from 'react'
import ReactScrollLink from '../General/ReactScollLink'
import Translation from '../General/Translation';
import TrailerItemSwitch from './TrailerItemSwitch';
import withIsInViewport from '../hooks/withIsInViewport';
import getBackgroundsUrlsObj from '../functions/getBackgroundsUrlsObj';
import { FRONT, UI_TRAILER } from '../constants/state';
import getData from '../functions/getData';
import { compose } from 'redux';
import { connect } from 'react-redux';
import toJS from '../hoc/toJS';
import FskWrapper from '../MovieInformation/FskWrapper';
import getAttributesDisplaySettings from '../functions/getAttributesDisplaySettings';
import getBluePrices from '../functions/getBluePrices';
import checkPerformanceFilterIsSet from '../functions/checkPerformanceFilterIsSet';
import ItemAttributesContainer from '../PosterFormatItem/ItemAttributesContainer';

const mapStateToProps = (state, ownProps) => ({
    hasYoutubeCookieConfirmation: getData(state, [UI_TRAILER, 'hasYoutubeCookieConfirmation']),
    cinemaDataFront: getData(state, FRONT),
})

const TrailerFormatItem = ({
    itemID, 
    itemData, 
    translation, 
    scrollToPosition, 
    onClickItem, 
    overviewFilterIgnoreOnPerformances,
    cinemaDataFront, 
    index = '', 
    showPerformances, 
    isMobile,
    shouldPlayTrailer = false, 
    queryStringValues,
    isConnectedFast,
    hasYoutubeCookieConfirmation,
    refElemViewport,
    isInViewport,
    setTrailerItemsInView
}) => {
    const { title, images, technologyAttributes, performances, titleDisplay, fsk, origTitle, trailerURL } = itemData
    const {
        poster_styling,
    } = cinemaDataFront
  
    const backgroundsObj = useMemo(
        () => getBackgroundsUrlsObj(images), 
        [images]
    )

    const containsOv = _.find(technologyAttributes, attribute => {
        return attribute.id === 'ovwefwfewef'
    })
    const currentTitle = titleDisplay ? titleDisplay : containsOv && origTitle ? origTitle : title 
    const borderClass = showPerformances ? ' theme-radius-posters-top' : ' theme-radius-posters-full'
    const performanceFilterIsSet = checkPerformanceFilterIsSet(technologyAttributes, null, null, queryStringValues)
    const {noAttributesToDisplay, technologyAttributesWithoutIcons, technologyAttributesWithIcons, noAttributesWithoutIconsToDisplay, noAttributesWithIconsToDisplay} = getAttributesDisplaySettings(technologyAttributes, performances, null, null, queryStringValues, performanceFilterIsSet, translation)
    const bluePricesClass = getBluePrices(technologyAttributes)

    return (
        <div className={'trailer-format-item-wrapper cursor-pointer'}> 
            <div className={"trailer-format-item" + bluePricesClass + ' ' + poster_styling} ref={refElemViewport}>       
                <ReactScrollLink className={"picture-wrapper" + borderClass} onClick={() => onClickItem({id: itemID, movieTitle: title, index: index})} to={scrollToPosition + ' openMovieInformation'} smooth={true} offset={-200}>
                    <TrailerItemSwitch
                        index={index}
                        isMobile={isMobile}
                        title={currentTitle} 
                        trailerURL={trailerURL}
                        backgroundImage={backgroundsObj.ambient}
                        fsk={fsk}
                        overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                        translation={translation} 
                        trailerAutoplay={true}
                        isInViewport={isInViewport}
                        shouldPlayTrailer={shouldPlayTrailer}
                        isConnectedFast={isConnectedFast}
                        hasYoutubeCookieConfirmation={hasYoutubeCookieConfirmation}
                        setTrailerItemsInView={setTrailerItemsInView}
                    />

                    {poster_styling === "hoveranimation" && <div className='poster-info'>
                        <FskWrapper fsk={fsk}/>

                        <div className='tickets-button'><div className='tickets-icon'></div><p className=''><Translation id="tickets" trans={translation}></Translation></p></div>                                
                        <div className='attributes-container'>
                            {!noAttributesToDisplay && <p className='text-bold attribute-wrapper-title'><Translation id="availableIn" trans={translation}>Verfügbar in</Translation>:</p>}
                            {!noAttributesWithIconsToDisplay && <div className='attributes-with-icons'>
                                <ItemAttributesContainer attributes={technologyAttributesWithIcons} canBeColored={true} />
                            </div>}
                            {!noAttributesWithoutIconsToDisplay && <div className='attributes-without-icons'>
                                <ItemAttributesContainer attributes={technologyAttributesWithoutIcons} />
                            </div>}
                        </div>
                    </div>}

                    {poster_styling === "fsk_on_poster"  && (fsk === 16 || fsk === 18) && <div className={"poster-info fsk-hint-poster theme-radius-posters-full"}>
                        <FskWrapper fsk={fsk}/>
                    </div>}
                </ReactScrollLink>
            </div>
        </div>
    )
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(withIsInViewport(TrailerFormatItem)) 